import { Link } from "react-router-dom";
import { Layout } from "../components/Layout";
import { ArrowRight, Target, Eye, Award } from "lucide-react";
import { whatsappLink } from "../data/constants";

export default function AboutPage() {
  return (
    <Layout>
      <section className="px-4 pt-6 sm:px-8">
        <div className="navy-grid-bg mx-auto max-w-7xl rounded-3xl border border-slate-800 p-8 text-white sm:p-14">
          <span className="font-spec text-xs font-semibold uppercase tracking-[0.2em] text-[#6EE7B7]">About Us</span>
          <h1 className="mt-3 max-w-3xl font-display text-4xl font-extrabold leading-tight sm:text-5xl">The Future Marketing</h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-300">
            A wholesale and distribution partner for premium flooring and matting — serving dealers, distributors,
            retailers, contractors and commercial projects across India with factory-direct pricing.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="grid gap-6 md:grid-cols-3">
          {[
            { icon: Target, title: "Our Mission", text: "Deliver premium-grade flooring and matting at genuine wholesale value, with reliable supply and custom-cut flexibility." },
            { icon: Eye, title: "Our Approach", text: "A quote-first, no-pressure model built for B2B. No carts, no checkout — just clear pricing and direct conversations." },
            { icon: Award, title: "Our Promise", text: "Durable, trusted products and honest specifications. Dimensions and details are always shown exactly as supplied." },
          ].map((c) => (
            <div key={c.title} className="rounded-2xl border border-slate-200 bg-white p-7 shadow-sm">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#ECFDF5] text-[#059669]"><c.icon className="h-6 w-6" /></span>
              <h3 className="mt-4 font-display text-xl font-bold text-[#0B1B3D]">{c.title}</h3>
              <p className="mt-2 leading-relaxed text-slate-600">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 rounded-3xl border border-[#A7F3D0] bg-[#ECFDF5] p-8 sm:flex-row sm:p-10">
          <div>
            <h3 className="font-display text-2xl font-bold text-[#0B1B3D]">Ready to order at wholesale scale?</h3>
            <p className="mt-1 text-slate-600">Browse the catalogue or message us for pricing.</p>
          </div>
          <div className="flex gap-3">
            <Link to="/catalogue" className="flex items-center gap-2 rounded-full bg-[#0B1B3D] px-6 py-3 text-sm font-bold text-white hover:bg-[#1E293B]">
              Explore Products <ArrowRight className="h-4 w-4" />
            </Link>
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="rounded-full bg-[#25D366] px-6 py-3 text-sm font-bold text-white hover:scale-105">WhatsApp</a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
